import React, { useMemo } from "react";
import { Box, Typography, Grid, Container } from "@mui/material";

import MetricCard from "../components/dashboard/MetricCard";
import PriorityQueue from "../components/dashboard/PriorityQueue";
import AlertsPanel from "../components/dashboard/AlertsPanel";
import PerformanceMiniChart from "../components/dashboard/PerformanceMiniChart";
import StageDistributionCard from "../components/dashboard/StageDistributionCard";
import RiskLeadsCard from "../components/dashboard/RiskLeadsCard";

import { mockConversations } from "../../mocks/mockConversations";
import { calculateDashboardMetrics } from "../utils/dashboardMetrics";

export default function DashboardPage() {
  const metrics = useMemo(() => calculateDashboardMetrics(mockConversations), []);
  const stageDistribution = metrics?.stageDistribution || {};
  const riskLeads = metrics?.riskLeads || [];
  const performanceSeries = metrics?.performanceSeries || metrics?.conversionTrend || [];

  return (
    <Container maxWidth="xl" disableGutters>
      <Box sx={{ px: { xs: 2, md: 3 }, py: { xs: 2.5, md: 3 } }}>
        {/* Header */}
        <Box sx={{ mb: 2.5 }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 950,
              color: "var(--cise-blue)",
              letterSpacing: -0.8,
              lineHeight: 1.05,
            }}
          >
            Dashboard
          </Typography>

          <Typography sx={{ color: "var(--cise-text-muted)", mt: 0.8 }}>
            Visão geral da operação SDR — Cultura Inglesa de Sergipe
          </Typography>
        </Box>

        {/* KPIs */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          {[
            { title: "Leads Hoje", value: metrics.leadsHoje, subtitle: "entraram hoje" },
            { title: "Sem Resposta", value: metrics.semResposta, subtitle: "exigem atenção" },
            { title: "Agendamentos", value: metrics.agendamentosHoje, subtitle: "para hoje" },
            { title: "Matrículas", value: metrics.matriculasMes, subtitle: "no mês atual" },
            { title: "Total Alunos", value: metrics.totalAlunos, subtitle: "em toda escola" },
            { title: "Faltam", value: metrics.diasParaFerias, subtitle: "dias para iniciar as férias" },
            { title: "Qualificados", value: metrics.qualificados ?? "-", subtitle: "prontos p/ avançar" },
            {
              title: "Leads em Risco",
              value: metrics.leadsEmRisco ?? (Array.isArray(riskLeads) ? riskLeads.length : "-"),
              subtitle: "+24h sem resposta",
            },
          ].map((m, idx) => (
            <Grid key={idx} item xs={6} sm={4} md={3}>
              <MetricCard {...m} />
            </Grid>
          ))}
        </Grid>

        {/* Bento grid */}
        <Grid container spacing={2}>
          {/* Coluna esquerda (empilha bem no mobile) */}
          <Grid item xs={12} lg={4}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <AlertsPanel minHeight={220} />
              </Grid>
              <Grid item xs={12}>
                <StageDistributionCard data={stageDistribution} minHeight={260} />
              </Grid>
            </Grid>
          </Grid>

          {/* Coluna central */}
          <Grid item xs={12} lg={4}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <RiskLeadsCard data={riskLeads} minHeight={260} />
              </Grid>
              <Grid item xs={12}>
                <PerformanceMiniChart
                  title="Performance (últimos dias)"
                  subtitle="volume / conversão / eficiência"
                  data={performanceSeries}
                  minHeight={220}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Coluna direita (prioridade maior) */}
          <Grid item xs={12} lg={4} width={"100%"}>
            <PriorityQueue minHeight={510} />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}